import Vue from 'vue'
import VueSegmentAnalytics from 'vue-segment-analytics'

export default function (context, inject) {
	const defaultCdn = 'https://cdn.segment.com'
	const router = context.app ? context.app.router : undefined

	Vue.use(VueSegmentAnalytics, {
		id: process.env.segmentApiKey,
		router,
		pageCategory: '',
		cdnHost: process.env.segmentCdnHost || defaultCdn
	})

	if (Vue.$segment) {
		inject('segment', Vue.$segment)
	}
}
